<template>
  <v-icon :class="$style.iconSize"> fas fa-location-arrow </v-icon>
</template>

<script>
export default {
  name: "vc-share-post-source-icon"
};
</script>

<style module>
.iconSize {
  font-size: 14px;
}
</style>
